var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_947_5589",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_947_5589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.33333 14.1667H12.1667V12.5H6.33333V14.1667ZM6.33333 10.8333H14.6667V9.16667H6.33333V10.8333ZM6.33333 7.5H14.6667V5.83333H6.33333V7.5ZM4.66667 17.5C4.20833 17.5 3.81597 17.3368 3.48958 17.0104C3.16319 16.684 3 16.2917 3 15.8333V4.16667C3 3.70833 3.16319 3.31597 3.48958 2.98958C3.81597 2.66319 4.20833 2.5 4.66667 2.5H16.3333C16.7917 2.5 17.184 2.66319 17.5104 2.98958C17.8368 3.31597 18 3.70833 18 4.16667V15.8333C18 16.2917 17.8368 16.684 17.5104 17.0104C17.184 17.3368 16.7917 17.5 16.3333 17.5H4.66667ZM4.66667 15.8333H16.3333V4.16667H4.66667V15.8333Z",
    fill: "#757575"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNote);
export default __webpack_public_path__ + "static/media/ic-note.493bf1a7968fb4563e3340c0f793843d.svg";
export { ForwardRef as ReactComponent };